module.exports = __webpack_public_path__ + "resources/icon-letter-front.a3078e2ed5d0462d.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/game-lottery/component/lottery-dialog-rolling/img/icon-letter-front.png
// module id = 825
// module chunks = 0 1